// Vue
import { computed, ComputedRef } from 'vue'

// State
import {getAutocompleteState} from '../state/autocompleteState'

const accommodationsResults: ComputedRef<number> = computed(() => {
    const autocompleteState = getAutocompleteState()
    return autocompleteState.state.accommodations.length
})

export default accommodationsResults
